import { useContext } from 'react';
import type { SettingsContextType } from './SettingsContext';
import { SettingsContext } from './SettingsContext';

export const useAskPatBeta = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      'useAskPatBeta must be used within a SettingsProvider'
    );
  }
  const { settings, updateSettings } = context;

  return {
    isAskPatEnabled: settings.beta.askPat,
    enableAskPat: () =>
      updateSettings({
        beta: { ...settings.beta, askPat: true },
      }),
    disableAskPat: () =>
      updateSettings({
        beta: { ...settings.beta, askPat: false },
      }),
    toggleAskPat: () =>
      updateSettings({
        beta: {
          ...settings.beta,
          askPat: !settings.beta.askPat,
        },
      }),
  };
};

export const useTheme = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      'useTheme must be used within a SettingsProvider'
    );
  }
  const { settings, updateSettings } = context;

  return {
    theme: settings.ui.theme,
    colorBlind: settings.ui.colorBlind,
    setTheme: (theme: 'light' | 'dark') =>
      updateSettings({
        ui: { ...settings.ui, theme },
      }),
    toggleColorBlind: () =>
      updateSettings({
        ui: { ...settings.ui, colorBlind: !settings.ui.colorBlind },
      }),
  };
};

export const useSettings = (): SettingsContextType => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error(
      'useSettings must be used within a SettingsProvider'
    );
  }
  return context;
};
